import React, { useContext, useState } from 'react'
import { M_Table, M_MessageBoard, M_Button, LoadingContext, BufferService, NavigateContext } from 'src/M_Components'
import { useTranslation } from 'react-i18next'
import { ContentCopy } from '@mui/icons-material'

export const QuoteList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const [refresh, setRefresh] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [quoteToDelete, setQuoteToDelete] = useState()
    const bufferServiceQuote = new BufferService('Quote')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const roleName =
        roles.find(r => /^quoterequest/i.test(r))
            ? 'quoteRequest'
            : roles.find(r => /^quote/i.test(r))
                ? 'Quote'
                : '';

    const NewRoute = (url, label, operation, data) => {
        const tempPerm = []

        roles.forEach((role) => {
            if (role.match('Quote') && !role.toLowerCase().startsWith('quoterequest')) {
                tempPerm.push(role.split('Quote')[1])
            } else if (role.toLowerCase().startsWith('quoterequest')) {
                tempPerm.push(role.split('quoteRequest')[1] ?? role.split('QuoteRequest')[1])
            }
        })

        // onlyRequests = true apenas se NÃO existir nenhuma role de Quote puro
        // roles.some() garante que não depende da ordem das roles no array
        const onlyRequests = !roles.some(r => r.match('Quote') && !r.toLowerCase().startsWith('quoterequest'))

        // Garantir que sempre temos linhas
        const selectedLines = selectedRows && selectedRows.length > 0
            ? selectedRows
            : (data ? [data] : [])

        ctx.passValue?.set('operation', operation)

        if (operation === 'create') {
            onlyRequests
                ? ctx2.newTab('go/quoteRequest', t("RequestQuote"))
                : ctx2.newTab('go/quoteDetail', t("CreateQuote"))
            return
        }

        // VALIDAR seleção
        if (!data && selectedLines.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }

        // COPY — sempre vai para quoteDetail
        if (operation === 'copyHeader' || operation === 'copyHeaderAndCharges') {
            ctx.passValue.set('Row', data)
            ctx.passValue.set('Rows', selectedLines)
            ctx2.newTab('go/quoteDetail', t("CopyQuote"))
            return
        }

        // EDIT
        if (operation === 'edit') {
            ctx.passValue.set('Row', data)
            ctx.passValue.set('Rows', selectedLines)
            onlyRequests
                ? ctx2.newTab('go/quoteRequest', t("EditRequestQuote"))
                : ctx2.newTab('go/quoteDetail', t("EditQuote"))
            return
        }
    }

    const deleteQuote = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        if (Array.isArray(tempData)) {
            ctx.passValue.delete('lines')
            deleteFunc(tempData[tempData.length - 1].Id)
            return
        }
        deleteFunc(tempData.Id)
    }

    const getExtraButtons = () => {
        const tempButtons = []
        const tempPerm = []

        roles.forEach((role) => {
            if (role.match('Quote')) {
                tempPerm.push(role.split('Quote')[1])
            }
        })

        if (tempPerm.includes('Create')) {
            tempButtons.push({ label: t('CopyHeader'), element: 'default', icon: <ContentCopy />, command: (data) => { NewRoute('', '', 'copyHeader', data) } })
            tempButtons.push({ label: t('CopyHeaderAndCharges'), element: 'default', icon: <ContentCopy />, command: (data) => { NewRoute('', '', 'copyHeaderAndCharges', data) } })
        }

        return tempButtons
    }

    function deleteFunc(id) {
        bufferServiceQuote.delete(id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorQuote"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessQuoteDeleted"))
            setRefresh(true)
            setOpenDeleteDialog(false)
        })
    }

    const removeContextItems = ['View', 'Copy']

    return (
        <div className='backgroundForms'>
            < div >
                <div>
                    <M_Table
                        roleName={roleName}
                        filtersOnTable
                        entityName={'quote'}
                        tablesOrder={tablesOrder}
                        onTablesOrderUpdate={onTablesOrderUpdate}
                        removeContextItems={removeContextItems}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        rolePermissions={roles}
                        replaceFunctions={new Map([
                            ['Delete', (data) => {
                                setQuoteToDelete(data)
                                setOpenDeleteDialog(true)
                                //deleteQuote(data)
                            }],
                            ['Create', (data) => NewRoute('', '', 'create', data)],
                            ['Edit', (data) => NewRoute('', '', 'edit', data)]
                        ])}
                        onPassLine={(rows) => {
                            setSelectedRows(rows)
                            // ctx.passValue.set('Rows', rows)
                        }}
                        extraButtons={getExtraButtons()}
                    />
                </div>
                <div className='dividerTables'></div>
            </div>
            <M_MessageBoard
                warning
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                title={`${t("Delete")} ${t("Quote")}?`}
                body={<span>
                    {t("TitleConfirmDelete")} <b>{t("Quote")}</b>
                </span>}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteDialog(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteQuote(quoteToDelete)}
                        />
                    </div>
                }
            />
        </div >
    )
}
